import Icon from "@/components/Icon";

import cover01 from "@/assets/images/cover01.png";
import cover02 from "@/assets/images/cover02.png";
import cover03 from "@/assets/images/cover03.png";
import cover04 from "@/assets/images/cover04.png";
import cover05 from "@/assets/images/cover05.png";
import cover06 from "@/assets/images/cover06.png";
import cover07 from "@/assets/images/cover07.png";
import cover08 from "@/assets/images/cover08.png";
import cover09 from "@/assets/images/cover09.png";

const DRAW_SERVICE_ID = {
  dev: "1bvtkyLbcKbtuX1JhJ9kQfSRot2",
  test: "1bvtkyLbcKbtuX1JhJ9kQfSRot2",
  pro: "1ctNkgDXiGxHVtreuhPu2SC9Lwh",
};

const CHAT_SERVICE_ID = {
  dev: "1hiksRCJq7CE4m5v9VUYIYHJaIE",
  test: "1hiksRCJq7CE4m5v9VUYIYHJaIE",
  pro: "1iJcV8aAYZxza8KNIGpxPTZgJAE",
};

const SERVER_OPT_TYPE = {
  create: "create",
  edit: "edit"
};

const REACTION_TYPE = {
  create: "create"
};

const USER_ROLE = {
  owner: "owner",
  user: "user",
  moderator: "moderator",
  robot: "robot"
};

const ERROR_CODE = {
  noAuth: "token not assign error",
  loginFailed: "login failed",
  notLogin: "not login",
  recallTimeout: "exceed recall time limit",
  userNotFound: "user not found",
  invalidPassword: "invalid password",
  registerUnique: "duplicate_unique_property_exists",
  sendMsgBlock: "blocked",
  muted: "you were muted",
  trafficLimit: "traffic limit",
};

const CHAT_TYPE = {
  single: "singleChat",
  groupChat: "groupChat"
};
const INVITE_TYPE = {
  inviteServer: "invite_server",
  inviteChannel: "invite_channel"
};
const ACCEPT_INVITE_TYPE = {
  acceptInviteServer: "join_server",
  acceptInviteChannel: "join_channel"
};

const MESSAGE_ITEM_SOURCE = {
  single: "singleChat",
  groupChat: "groupChat",
  threadChat: "threadChat",
  threadParentMsg: "threadParentMsg"
};

const SCROLL_WARP_ID = "scrollMsgWrapId";

const CHANNEL_EVENT = {
  destroy: "destroy",
  update: "update",
  removed: "removed",
  inviteToJoin: "inviteToJoin",
  memberPresence: "memberPresence",
  memberAbsence: "memberAbsence",
  muteMember: "muteMember",
  unmuteMember: "unmuteMember",
  rejectInvite: "rejectInvite",
  acceptInvite: "acceptInvite"
};

const MULTI_DEVICE_EVENT = {
  //server
  serverCreate: "serverCreate",
  serverDestroy: "serverDestroy",
  serverUpdate: "serverUpdate",
  serverJoin: "serverJoin",
  serverRemoved: "serverRemoved",
  serverLeave: "serverLeave",
  serverRemoveMember: "serverRemoveMember",
  serverInviteUser: "serverInviteUser",
  serverAcceptInvite: "serverAcceptInvite",
  serverRefuseInvite: "serverRefuseInvite",
  serverSetRole: "serverSetRole",
  //channel
  channelCreate: "channelCreate",
  channelDestroy: "channelDestroy",
  channelUpdate: "channelUpdate",
  channelJoin: "channelJoin",
  channelLeave: "channelLeave",
  channelRemoveMember: "channelRemoveMember",
  channelInviteUser: "channelInviteUser",
  channelMuteMember: "channelMuteMember",
  channelUnMuteMember: "channelUnMuteMember",
  channelAcceptInvite: "channelAcceptInvite",
  channelRejectInvite: "channelRejectInvite",
  //thread
  chatThreadCreate: "chatThreadCreate",
  chatThreadDestroy: "chatThreadDestroy",
  chatThreadJoin: "chatThreadJoin",
  chatThreadLeave: "chatThreadLeave",
  //category
  categoryCreate: "categoryCreate",
  categoryUpdate: "categoryUpdate",
  categoryDestroy: "categoryDestroy",
  categoryTransferChannel: "categoryTransferChannel",
};

const CHAT = {
  label: (
    <div style={{ width: "222px", display: "flex", alignItems: "center", height: "38px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "4px", height: " 30px", width: "30px" }}><Icon name="message" size="18px" /></div>
      <span style={{ marginLeft: " 8px", fontFamily: "Microsoft YaHei UI", fontWeight: "500", fontSize: "14px", lineHeight: "20px" }}>发起私聊</span>
    </div>
  ),
  key: "chat"
};

const UN_MUTE = {
  label: (
    <div style={{ width: "222px", display: "flex", alignItems: "center", height: "38px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "4px", height: " 30px", width: "30px" }}><Icon name="person_wave" size="18px" /></div>
      <span style={{ marginLeft: " 8px", fontFamily: "Microsoft YaHei UI", fontWeight: "500", fontSize: "14px", lineHeight: "20px" }}>取消禁言</span>
    </div>
  ),
  key: "unmute"
};

const MUTE = {
  label: (
    <div style={{ width: "222px", display: "flex", alignItems: "center", height: "38px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "4px", height: " 30px", width: "30px" }}><Icon name="person_wave_slash" size="18px" /></div>
      <span style={{ marginLeft: " 8px", fontFamily: "Microsoft YaHei UI", fontWeight: "500", fontSize: "14px", lineHeight: "20px" }}>成员禁言</span>
    </div>
  ),
  key: "mute"
};

const KICK = {
  label: (
    <div style={{ width: "222px", display: "flex", alignItems: "center", height: "38px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "4px", height: " 30px", width: "30px" }}><Icon name="minus_in_circle" size="18px" /></div>
      <span style={{ marginLeft: " 8px", fontFamily: "Microsoft YaHei UI", fontWeight: "500", fontSize: "14px", lineHeight: "20px" }}>踢出频道</span>
    </div>
  ),
  key: "kick"
};

const SERVER_COVER_MAP = {
  cover01: cover01,
  cover02: cover02,
  cover03: cover03,
  cover04: cover04,
  cover05: cover05,
  cover06: cover06,
  cover07: cover07,
  cover08: cover08,
  cover09: cover09
};

const LOGIN_PASSWORD = "123456";
//177910171-3d66

const THREAD_PAGE_SIZE = 10;
const CHANNEL_PAGE_SIZE = 20;

/* 实验组与模型映射规则
  实验组1：默认选中展台，风格随机
  实验组2：默认选中概念建筑，风格随机
  实验组3：默认选中别墅建筑，风格随机
  实验组4：默认选中餐饮空间，风格随机
  对照组：默认选中客厅，风格随机（现有规则）
*/
const GROUP_MODEL_MAP = {
  dev: {
    1: 46, // 46为展台模型id
    2: 41, // 41为概念建筑模型id
    3: 43, // 43为别墅建筑模型id
    4: 48, // 48为餐饮空间模型id
  },
  test: {
    1: 46, // 46为展台模型id
    2: 41, // 41为概念建筑模型id
    3: 43, // 43为别墅建筑模型id
    4: 48, // 48为餐饮空间模型id
  },
  pro: {
    1: 12, // 12为展台模型id
    2: 8,  // 8为概念建筑模型id
    3: 11, // 11为别墅建筑模型id
    4: 10, // 10为餐饮空间模型id
  }
}

// AI面板类型枚举
const AI_PANEL_TYPE = {
  DRAW: '1',           // 绘画面板展示
  CO_CREATE: '2',      // 共创面板展示
  TRAIN_FORMAL: '3',   // 训练-正式版本展示
  TRAIN_TEST: '4',     // 训练-训练版本展示
  TRAIN_NEW: '5',      // 训练-新建训练展示
};

// 共创点击事件类型
const CO_CREATE_CLICK_TYPE = {
  CREATE_SAME: '1',    // 点击【创作同款】
  JOIN: '2',           // 点击【参与共创】
  INITIATE: '3',       // 点击【发起共创】
  BANNER: '4',         // 点击banner广告
};

// 作品展示 1-作品栏展示；2-点击图片查看大图；3-点击【画同款】按钮
const WORK_SHOW = {
  SHOW_UP: '1',
  AMPLIFY: '2',
  DRAW_SAME_THING: '3',
  ADV_ITEM: '5'
};

const COCREATE = 2; // 绘画类型 0.溜溜ai 1.绘画 2.共创 3.灵感图
const AI_ABILITY = {
  OPEN: 0,
  CLOSE: 1,
} // ai能力的打开状态

// 默认的模型(主题)
const DEFAULT_THEME = {
  dev: {
    id: 28,
    name: '别墅建筑',
    model_type: 1
  },
  test: {
    id: 28,
    name: '别墅建筑',
    model_type: 1
  },
  pro: {
    id: 28,
    name: '别墅建筑',
    model_type: 1
  }
}

// slider组件定制主题token
const SLIDER_THEME_TOKEN = {
  components: {
    Slider: {
      railBg: '#272C36', // 轨道背景色
      railHoverBg: '#272C36', // 轨道背景色（悬浮态）
      trackBg: '#64717C', // 轨道已覆盖部分背景色
      trackBgDisabled: '#525C6A', // 轨道禁用态背景色
      trackHoverBg: '#A0B7CA', // 轨道已覆盖部分背景色（悬浮态）
      railSize: 6, // 轨道高度
    }
  }
};

export {
  CHAT_SERVICE_ID,
  DRAW_SERVICE_ID,
  SERVER_OPT_TYPE,
  USER_ROLE,
  ERROR_CODE,
  CHAT_TYPE,
  MESSAGE_ITEM_SOURCE,
  INVITE_TYPE,
  ACCEPT_INVITE_TYPE,
  SCROLL_WARP_ID,
  MULTI_DEVICE_EVENT,
  CHANNEL_EVENT,
  CHAT,
  UN_MUTE,
  MUTE,
  KICK,
  REACTION_TYPE,
  SERVER_COVER_MAP,
  LOGIN_PASSWORD,
  THREAD_PAGE_SIZE,
  CHANNEL_PAGE_SIZE,
  GROUP_MODEL_MAP,
  AI_PANEL_TYPE,
  CO_CREATE_CLICK_TYPE,
  WORK_SHOW,
  COCREATE,
  AI_ABILITY,
  DEFAULT_THEME,
  SLIDER_THEME_TOKEN
};
